import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isString } from 'lodash';
import { Stack, Typography, Button } from '@metarouter-private/mr-mui';

import { sortKeysDeep, TRUNCATION_THRESHOLD } from '@ion/api/audit-logs/format/stringify-value';

function toDisplayString(value) {
  return isString(value) ? value : JSON.stringify(sortKeysDeep(value));
}

function toPrettyDisplayString(value) {
  return isString(value) ? value : JSON.stringify(sortKeysDeep(value), null, 2);
}

export default function ComplexValueDisclosure({ value, truncated, testId }) {
  const [expanded, setExpanded] = useState(false);
  const full = toDisplayString(value);
  const preview = truncated ? `${full.slice(0, TRUNCATION_THRESHOLD)}…` : full;

  return (
    <Stack data-test-id={testId} spacing={0.5}>
      <Typography component="pre" variant="body2" sx={{ m: 0, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
        {expanded ? toPrettyDisplayString(value) : preview}
      </Typography>
      {truncated && (
        <Button size="small" aria-expanded={expanded} onClick={() => setExpanded(current => !current)}>
          {expanded ? 'Show less' : 'Show more'}
        </Button>
      )}
    </Stack>
  );
}

ComplexValueDisclosure.propTypes = {
  value: PropTypes.any.isRequired,
  truncated: PropTypes.bool.isRequired,
  testId: PropTypes.oneOf(['auditLogComplexValue', 'auditLogTruncatedValue']).isRequired,
};
